import { Checkbox, Filters, IndexFilters, IndexFiltersMode } from '@shopify/polaris';
import type { IndexFiltersProps } from '@shopify/polaris';
import { useState } from 'react';

type Props = Omit<IndexFiltersProps, 'mode' | 'setMode' | 'cancelAction'> & {
    hasVehicleContext: boolean;
    mappedOnly: boolean;
    onMappedOnlyChange: (checked: boolean) => void;
};

/** Shared browsing controls with the mapping filter in the search toolbar. */
const MappingFilters = ({ hasVehicleContext, mappedOnly, onMappedOnlyChange, ...props }: Props) => {
    const [focused, setFocused] = useState(true);

    const controls = (
        <div className="pf-mapping-filters__controls">
            <div className="pf-mapping-filters__mapped">
                <Checkbox
                    label="Show mapped only"
                    checked={hasVehicleContext && mappedOnly}
                    disabled={!hasVehicleContext}
                    onChange={onMappedOnlyChange}
                />
            </div>
            <div className="pf-mapping-filters__actions">
                <IndexFilters
                    {...props}
                    mode={IndexFiltersMode.Default}
                    setMode={() => {}}
                    hideFilters
                    hideQueryField
                    loading={false}
                    disableStickyMode
                    disableKeyboardShortcuts
                />
            </div>
        </div>
    );

    return (
        <div className="pf-mapping-filters">
            <Filters
                queryValue={props.queryValue}
                queryPlaceholder={props.queryPlaceholder}
                onQueryChange={props.onQueryChange}
                onQueryClear={props.onQueryClear}
                onClearAll={props.onClearAll}
                filters={props.filters}
                appliedFilters={props.appliedFilters}
                loading={props.loading}
                focused={focused}
                onQueryFocus={() => setFocused(true)}
                onQueryBlur={() => setFocused(false)}
                borderlessQueryField
            >
                {controls}
            </Filters>
        </div>
    );
};

export default MappingFilters;
